export const SORTABLE_METRIC_TYPE = `metric`;
